import { selector } from './selector';

const PagePaymentLoadingForm = (function ($) {

    var intervalId;
    var success = false;
    function startInterval() {
        intervalId = setInterval(checkData, 3000);
    }

    function checkData() {
        $.ajax({
            url: $(selector.checkUrl).val(),
            type: 'GET',
            success: function (data, textStatus, xhr) {
                if (data.html) {
                    success = true;
                    stopInterval()
                    $(selector.data).html(data.html);
                } else if (data.redirect) {
                    success = true;
                    stopInterval()
                    window.location.href = response.redirect
                }
            },
            error: function (xhr) {
            }
        });
    }

    function stopInterval() {
        $(selector.spiner).css('display', 'none')
        clearInterval(intervalId);
    }

    function initialize() {
        startInterval();
        setTimeout(function () {
            stopInterval();
            if (!success) {
                window.location.href = $(selector.errorUrl).val();
            }
        }, 20000);
    }

    return {
        init: initialize
    }
})(jQuery);

export { PagePaymentLoadingForm };